module.exports = __webpack_public_path__ + "static/media/Portrait-10207.d6ffceec.jpg";